























import Vue from 'vue';
import {IJourneyDetails} from "./JourneyDetails";
import {Component, Prop} from "vue-property-decorator";
import {IRefundStatusJourney} from "./IRefundStatusJourney";
import AppealsEmail from './AppealsEmail.vue';

@Component({
    components: {
        AppealsEmail
    }
})
export default class RefundUnavailable extends Vue {
    @Prop() details: IJourneyDetails;
    @Prop() refundData: IRefundStatusJourney;
    @Prop() appealsEmail: string;

    mounted() {
        const titleParts = document.title.split(" - ");
        titleParts[0] = "Refund Unavailable";
        document.title = titleParts.join(" - ");
    }

    errorReason() {
        // Email -> Nick, 9 Nov
        const availableRefund = this.refundData.ticketsRefundValue - this.refundData.adminFee;
        const availableReplacement = this.refundData.ticketsReplaceValue - this.refundData.adminFeeReplacement;

        if (this.refundData.isCancelled) {
            return "it looks like you've already received a refund";
        } else if (this.refundData.isScanned) {
            return "our records indicate you may have already used this ticket";
        }

        if (availableRefund <= 0 && availableReplacement <= 0) {
            return "no refund is available"; // Email -> Nick, 19 Sep
        }

        return "something went wrong";
    }
}

